<div
  *ngIf="visible && aspectRatio && !mediaSrc"
  class="vm-media-container"
  [ngClass]="{
    'vm-media-container__aspect--full': aspectRatio === mediaTypes.OneToOne,
    'vm-media-container__aspect--two-one': aspectRatio === mediaTypes.TwoToOne,
    'vm-media-container__aspect--sixteen-nine': aspectRatio === mediaTypes.SixteenToNine
  }"
>
  <video *ngIf="mediaType === 'video'" controls preload="metadata" title="{{ altText }}">
    <source type="video/mp4" src="{{ src }}" />
    <source type="video/webm" src="{{ src }}" />
  </video>

  <img *ngIf="mediaType === 'image'" alt="{{ altText }}" src="{{ src }}" loading="lazy" />
</div>
<ng-container *ngIf="visible && !aspectRatio && mediaType === 'image'">
  <img
    *ngIf="src"
    class="vm-media-container__image"
    alt="{{ altText }}"
    src="{{ src }}"
    loading="lazy"
    [ngClass]="{
      'contain-media': containMedia,
      'cover-media': coverMedia,
      'contain-media-scale-down': containMediaScaleDown
    }"
  />
</ng-container>

<div *ngIf="visible && multiple && mediaSrc">
  <picture>
    <source
      type="image/webp"
      *ngFor="let sourceList of mediaSrc?.breakpoints | multisourcevariantfilter: exclude"
      [srcset]="sourceList.webpurl != null ? sourceList.webpurl : sourceList.url"
      media="(min-width: {{ sourceList.width }}px)"
    />
    <img
      [src]="mediaSrc.default"
      loading="lazy"
      [ngClass]="{
        'contain-media': containMedia,
        'cover-media': coverMedia,
        'contain-media-scale-down': containMediaScaleDown
      }"
    />
  </picture>
</div>

<div *ngIf="visible && !multiple && mediaSrc">
  <video *ngIf="mediaType === 'video'" title="{{ altText }}" width="100%" controls loop autoplay>
    <source type="video/mp4" src="{{ mediaSrc?.default }}" />
  </video>
  <picture *ngIf="mediaType === 'image'">
    <source
      type="image/webp"
      *ngFor="let sourceList of breakpoints | multisourcevariantfilter: exclude"
      [srcset]="sourceList.webpurl != null ? sourceList.webpurl : sourceList.url"
      media="(min-width: {{ sourceList.width }}px)"
    />
    <img
      [src]="mediaSrc?.default"
      [ngClass]="{
        'contain-media': containMedia,
        'cover-media': coverMedia,
        'contain-media-scale-down': containMediaScaleDown
      }"
    />
  </picture>
</div>
